import React from "react";

function Contact() {
    return (
    <p>This is how you contact us:</p>
    );
}

export default Contact;